import {Superstars} from "../models/models.js";
import {getSuperstarManagedSuperstars, getSuperstarTagTeams} from "../models/superstar.js";
import {getTagTeamSuperstars} from "../models/tagTeam.js";
import {objectInArray, getUniqueObjects, getCurrentGame} from "./helpers.js";
import {getGameCurrentUserCompany} from "./games.js";
import {getCompanyRosterByType} from "./companies.js";
import {getRosterSuperstars} from "../models/roster.js";

async function getManagerData(manager, rosterSuperstars = null) {  // get_manager_data
    let data = {};

    data["name"] = manager.name;
    data["charisma"] = manager.charisma;
    if (manager.hot) {
        data["charisma"] += 1
    }
    data["hot"] = manager.hot;
    data["fullTimeManager"] = manager.fullTimeManager;
    data["uid"] = manager.$loki;

    // Get managed talent names
    const managedTalent = await getManagerManagedTalent(manager, rosterSuperstars);
    data["managedTalentNames"] = managedTalent.map(x => x.name);

    return data;
}

async function getManagerManagedTalent(manager, rosterSuperstars = null, checkAvailable = false,
                                       managedSuperstars = null) {  // get_manager_managed_talent

    // Check availability for manager promo segment
    function checkManagedTalentAvailability(talent) {
        return !checkAvailable || !talent.unavailable && talent.suspensionMonths <= 0;
    }

    // Get managed superstars
    if (managedSuperstars === null) {
        if (rosterSuperstars) {
            managedSuperstars = rosterSuperstars.filter(x => x.managerId === manager.$loki);
        }
        else {
            managedSuperstars = [...await getSuperstarManagedSuperstars(manager)]
        }
    }

    // Get managed talent (get team names, if found, instead of individual superstar names)
    let managedTalent = [];
    for (const managedSuperstar of managedSuperstars) {

        // Get superstar's teams that have all members managed by manager
        let managedTeamFound = false;
        const superstarTagTeams = (await getSuperstarTagTeams(managedSuperstar)).filter(y => !y.temporary);
        for (const superstarTagTeam of superstarTagTeams) {
            const tagTeamSuperstars = await getTagTeamSuperstars(superstarTagTeam);
            if (tagTeamSuperstars.every(
                s => objectInArray(s, managedSuperstars) && checkManagedTalentAvailability(s))
            ) {
                managedTeamFound = true;
                managedTalent.push(superstarTagTeam);
            }
        }

        // Get superstar if no managed team found
        if (!managedTeamFound && checkManagedTalentAvailability(managedSuperstar)) {
            managedTalent.push(managedSuperstar)
        }
    }

    // Remove duplicates
    managedTalent = getUniqueObjects(managedTalent);

    return managedTalent;
}

async function getManagedTalentForManager({managerUid} = {}) {  // get_managed_talent_for_manager
    let data = {};
    const currentGame = await getCurrentGame();
    const userCompany = await getGameCurrentUserCompany(currentGame);
    const mainRoster = await getCompanyRosterByType(userCompany, 'main');
    const rosterSuperstars = await getRosterSuperstars(mainRoster);

    let manager = await Superstars.get(managerUid);
    let managedTalent = [];
    if (manager) {
        managedTalent = await getManagerManagedTalent(manager, rosterSuperstars, true)
    }

    data['managedTalent'] = managedTalent.map(x => {
        return {'name': x.name, 'uid': x.$loki}
    });

    return data;
}

function setManagersForMatchOrSegment() {  // set_managers_for_match_or_segment
    return
}

function setupSetManagersForMatchOrSegment(newFunction) {
    setManagersForMatchOrSegment = newFunction
}

function addSuperstarManagerToMatchOrSegment(matchOrSegment, superstar, manager) {  // add_superstar_manager_to_match_or_segment
    // Add manager to superstar if not already added to a superstar in the match/segment
    if (!(Object.values(matchOrSegment.managersUsed).includes(manager.$loki))) {
        matchOrSegment.managersUsed[String(superstar.$loki)] = manager.$loki;
        return true;
    }
    return false;
}

function removeSuperstarManagerFromMatchOrSegment(matchOrSegment, superstar) {  // remove_superstar_manager_from_match_or_segment
    // Remove manager from superstar if present
    delete matchOrSegment.managersUsed[String(superstar.$loki)];
    return true;
}

export {getManagerData, getManagerManagedTalent, getManagedTalentForManager, setManagersForMatchOrSegment,
    addSuperstarManagerToMatchOrSegment, removeSuperstarManagerFromMatchOrSegment, setupSetManagersForMatchOrSegment}